import React from "react";
import { Button, Card, Input, Label } from "../../../ui";

interface PasswordChangeViewProps {
  currentPassword: string;
  newPassword: string;
  onCurrentPasswordChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onChangePassword: () => void;
}

export function PasswordChangeView({
  currentPassword,
  newPassword,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onChangePassword,
}: PasswordChangeViewProps) {
  return (
    <Card className="mb-6 p-5">
      <h2 className="mb-4 text-lg font-semibold text-foreground">Change Password</h2>
      <div className="flex max-w-md flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="current-password">Current password</Label>
          <Input
            id="current-password"
            type="password"
            value={currentPassword}
            onChange={(e) => onCurrentPasswordChange(e.target.value)}
            placeholder="Current password"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="new-password">New password</Label>
          <Input
            id="new-password"
            type="password"
            value={newPassword}
            onChange={(e) => onNewPasswordChange(e.target.value)}
            placeholder="New password"
          />
        </div>
      </div>
      <div className="mt-4 flex justify-end">
        <Button onClick={onChangePassword}>Update Password</Button>
      </div>
    </Card>
  );
}
